<template>
  <div class="SelectList">
    <van-cell-group>
      <van-field label="学年：" v-model="schoolYear" placeholder="请选择学年" @click="getYeardata" />
      <van-field label="学期：" v-model="schoolTerm" placeholder="请选择学期" @click="getTremdata" />
    </van-cell-group>
    <ul class="crouse-ul" v-if="data.length > 0">
      <li v-for="crousePlan in data" :key="crousePlan.CollectionID">
        <div class="clearfix select-body">
          <div class="fl">
            <img :src="courseUrl" />
          </div>
          <div class="fl">
            <h2 v-cloak style="font-size:15px;line-height:30px;">{{crousePlan.ClassTableName}}</h2>
          </div>
        </div>
        <div class="clearfix select-body">
          <div class="fl">
            <div class="type-span">
              <span class="type-name" v-cloak>{{crousePlan.ClassTableTypeName}}</span>
            </div>
          </div>
          <div class="fr">
            <div class="type-span">
              <span class="select-in" v-cloak>{{crousePlan.StatusText}}</span>
            </div>
          </div>
        </div>
        <div class="select-footer">
          <div>
            <div
              class="crouse-date"
              v-if="crousePlan.SubjectDescriptionStartDate !=='' && crousePlan.SubjectDescriptionEndDate !==''"
            >
              <span>预览时间：</span>
              <span
                style="font-size:12px;"
                v-cloak
              >{{xy.moment(crousePlan.SubjectDescriptionStartDate).format('YYYY-MM-DD HH:mm')}} 至 {{xy.moment(crousePlan.SubjectDescriptionEndDate).format('YYYY-MM-DD HH:mm')}}</span>
            </div>
            <div
              class="crouse-date"
              v-if="crousePlan.FormalChoseStartDate !=='' && crousePlan.FormalChoseEndDate !==''"
            >
              <span>选课时间：</span>
              <span
                style="font-size:12px;"
                v-cloak
              >{{xy.moment(crousePlan.FormalChoseStartDate).format('YYYY-MM-DD HH:mm')}} 至 {{xy.moment(crousePlan.FormalChoseEndDate).format('YYYY-MM-DD HH:mm')}}</span>
            </div>
          </div>
          <div class="clearfix">
            <div class="fl">
              <span
                style="line-height:30px;color:rgba(153,153,153,1);margin-left: 5px;"
              >{{crousePlan.SelectCount}}人已选</span>
            </div>
            <div class="fr">
              <span
                class="mobile-online-btn"
                v-if="crousePlan.Status === 1 && crousePlan.IsComplete === false"
                @click="loadSelectCourse(crousePlan)"
              >去选课</span>
              <span
                class="mobile-online-btn"
                v-if="crousePlan.Status === 1 && crousePlan.IsComplete === true"
                @click="loadSelectCourse(crousePlan)"
              >去重选</span>
              <span
                class="mobile-online-btn"
                v-if="crousePlan.Status === 0"
                @click="loadResult(crousePlan)"
              >查看选课结果</span>
              <span
                class="mobile-online-btn"
                v-if="crousePlan.Status === 1 && crousePlan.IsComplete === true &&crousePlan.ClassTableTypeID===4"
                @click="loadResult(crousePlan)"
              >选课结果</span>
              <span
                class="mobile-online-btn"
                v-if="crousePlan.Status === 9"
                @click="loadResult(crousePlan)"
              >去预览</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <van-popup v-model="yearShow" position="bottom" :style="{ height: '45%' }">
      <ul class="year" v-for="(item) in yearData" :key="item.ID">
        <li @click="choseYear(item)">{{item.Name}}</li>
      </ul>
    </van-popup>
    <van-popup v-model="termShow" position="bottom" :style="{ height: '45%' }">
      <ul class="term" v-for="(item) in termData" :key="item.AcademicSessionID">
        <li @click="choseSession(item)">{{item.AcademicSessionName}}</li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
export default {
  name: "SelectList",
  data() {
    return {
      courseUrl: courseUrl,
      schoolYear: "",
      schoolTerm: "",
      yearShow: false,
      yearData: [],
      yearId: "",
      termShow: false,
      termData: [],
      sessionId: "",
      data: []
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.getSchoolYear();
    },
    async getSchoolYear() {
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/comm/YearList"
      );
      if (res.success) {
        if (res.data.length) {
          this.yearData = res.data;
          this.yearData.filter(item => {
            if (item.IsCurrent) {
              this.schoolYear = item.Name;
              this.yearId = item.ID;
              this.getSchoolTerm();
            }
          });
        }
      }
    },
    async getSchoolTerm() {
      let res = await this.xyapi.get(
        this.xyMApi + "/xy/comm/SessionList",
        {
          yearID: this.yearId
        }
      );
      if (res.success) {
        if (res.data.length) {
          this.termData = res.data;
          this.termData.filter(item => {
            if (item.IsCurrent) {
              this.schoolTerm = item.AcademicSessionName;
              this.sessionId = item.AcademicSessionID;
              this.getCourse();
            }
          });
        }
      }
    },
    async getCourse() {
      this.data = [];
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetStudentSelectCourse",
        {
          yearId: this.yearId,
          academicSessionID: this.sessionId
        }
      );
      if (res.success) {
        if (res.data.length) {
          this.data = res.data;
        }
      }
    },
    getYeardata() {
      if (this.yearData.length) {
        this.yearShow = true;
      }
    },
    getTremdata() {
      if (this.termData.length) {
        this.termShow = true;
      }
    },
    choseYear(i) {
      this.yearId = i.ID;
      this.schoolYear = i.Name;
      this.yearShow = false;
      this.getSchoolTerm();
      this.data = [];
    },
    choseSession(i) {
      this.schoolTerm = i.AcademicSessionName;
      this.sessionId = i.AcademicSessionID;
      this.termShow = false;
      this.getCourse();
    },
    loadSelectCourse(col) {
      console.log(col);
      if (col.ClassTableTypeID === 3) {
        this.$router.push({
          name: "choseCourse",
          params: {
            classTableID: col.ClassTableID,
            CollectionID: col.CollectionID
          }
        });
      } else if (col.ClassTableTypeID === 4) {
        if (col.SelectCourseMode === 0) {
          this.$router.push({
            name: "choseCourseSchoolBase",
            params: {
              classTableID: col.ClassTableID,
              CollectionID: col.CollectionID
            }
          });
        }
        if (col.SelectCourseMode === 1) {
          this.$router.push({
            name: "choseCourseSchoolBaseGroup",
            params: {
              classTableID: col.ClassTableID,
              CollectionID: col.CollectionID
            }
          });
        }
      } else if (col.ClassTableTypeID === 10) {
        //分层选课
        this.$router.push({
          name: "layeredSelect",
          params: {
            ClassTableID: col.ClassTableID,
             CollectionID: col.CollectionID
          }
        });
      }
    },
    loadResult(col) {
      if (col.ClassTableTypeID === 3) {
        this.$router.push({
          name: "coursePreview",
          params: {
            classTableID: col.ClassTableID
          }
        });
      } else if (col.ClassTableTypeID === 4) {
        if (col.SelectCourseMode === 0) {
          this.$router.push({
            name: "choseCourseSchoolBasePreview",
            params: {
              classTableID: col.ClassTableID
            }
          });
        } else {
          this.$router.push({
            name: "choseCourseSchoolBasePreviewGroup",
            params: {
              classTableID: col.ClassTableID
            }
          });
        }
      } else if (col.ClassTableTypeID === 10) {
        //分层选课
        this.$router.push({
          name: "layeredPreview",
          params: {
            ClassTableID: col.ClassTableID,
            CollectionID: col.CollectionID
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.SelectList {
  .van-cell-group {
    position: fixed;
    z-index: 999;
    top: 88px;
  }
  .van-cell {
    width: 50%;
    float: left;
    ::v-deep .van-field__label {
      width: 100px;
    }
  }
  .year {
    text-align: center;
    li {
      line-height: 120px;
    }
  }
  .term {
    text-align: center;
    li {
      line-height: 120px;
    }
  }
  .crouse-ul {
    width: 90%;
    margin: 100px auto;
    li {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 12px 0px rgba(156, 156, 156, 0.4);
      border-radius: 28px;
      padding: 20px 20px 20px 20px;
      border-radius: 10px;
      margin-bottom: 20px;
    }
    .select-body {
      img {
        width: 52px;
        height: 57px;
        overflow: hidden;
        margin-right: 20px;
        position: relative;
      }
    }
    .type-span {
      margin: 15px 0;
      span {
        border-radius: 15px;
        padding: 4px 10px;
        margin-right: 8px;
      }
    }

    .type-name {
      padding: 10px 20px;
      background: rgba(255, 249, 242, 1);
      color: #f68d05;
    }
    .select-in {
      color: #09af18;
    }

    .select-complete {
      color: #12cb31;
      border: 1px solid #ff6266;
    }

    .select-preview {
      color: #12cb31;
      border: 1px solid #ff8c1b;
    }

    .perpson-num {
      color: #acb4bf;
    }

    .crouse-date {
      // width:592px;
      height: 59px;
      line-height: 59px;
      background: rgba(248, 248, 248, 1);
      border-radius: 13px;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      margin-bottom: 15px;
    }
    .mobile-online-btn {
      background: rgba(241, 240, 245, 1);
      box-shadow: 0px 2px 5px 0px rgba(179, 178, 182, 0.5);
      color: #2e7bfd;
      font-size: 28px;
      display: inline-block;
      margin: 0;
      padding: 12px 24px;
      border-radius: 29px;
      vertical-align: middle;
      text-align: center;
      text-overflow: ellipsis;
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>
